const Keys = {
    Lookup :  {
        Country: "categoryLookupAtom",
        Currency:  "currencyLookupAtom",
        StatDates: "statDatesLookupAtom",
        LandingPages: "landingPagesLookupAtom",
        AffiliatePrograms:  "AffiliateProgramsLookupAtom",
    },
    Account : {
        Auth: "authTokensAtom",
        AccountDetails: "accountDetailsAtom",
        Profiles: "accountProfilesAtom",
        PhoneDetails: "accountPhoneDetailsAtom",
        PaymentInfo: "accountPaymentInfoAtom",
        BankDetails: "accountBankDetailsAtom",
        BillingInfo: "accountBillingInfoAtom",
        PromoteChannels: "accountPromoteChannelsAtom",
        RegStep: "accountRegStepAtom",
        RHPLinkAccount: "accountRHPLinkAccountAtom"

    },  
    Nav: {
        LeftMenu: "navLeftMenuAtom"
    },
    Statistic : {
        CampaignDateRangeID : "statisticCampaignDateRangeIDAtom",
        DashboardCampaignSelection: "statisticDashboardCampaignSelectionAtom",
        DashboardSelectedMonth: "statisticDashboardSelectedMonthAtom",
    },
    Common : {
        ErrPopup: "commonErrPopupAtom"
    },
    Support : {
        TicketList: "supportTicketListAtom",
        TicketListSearchCriteria:  "supportTicketListSearchCriteriaAtom",
        TicketDetails: "supportTicketDetailsAtom"
    }
}

export default Keys;